<template>

    <div>

        <h1>Test Widget</h1>

        <ul>
            <li v-for="(content, index) in payload[0]" class="mb-4">
                <span v-if="content.legacy">
                    <span v-if="content.thumbnail_url">
                        <img :src="payload[2][index] + content.thumbnail_url" alt="" style="width: 150px;">
                    </span>
                    <span v-else>
                        Not Assigned
                    </span>
                </span>

                <span v-else>
                    <span v-if="content.thumbnail_url">
                        <img :src="payload[1][index] + content.thumbnail_url" alt="" style="width: 150px;">
                    </span>
                    <span v-else>
                        Not Assigned
                    </span>
                </span>

                <p>T: {{ content.title }}</p>

            </li>
        </ul>

    </div>

</template>

<script>

    export default {

        data() {

            return {

                payload: ''

            }

        },

        props: [
            'language',
            'category',
            'count'
        ],

        created() {

            if(this.category) {

                axios.get('/api/widget/payload/bycat/' + this.language + '/' + this.count + '/' + this.category)
                    .then(response => {
                        this.payload = response.data
                    })
                    .catch(error => {
                        console.log('Error getting data: ' + error)
                    })

            } else {

                axios.get('/api/widget/payload/' + this.language + '/' + this.count)
                    .then(response => {
                        this.payload = response.data
                    })
                    .catch(error => {
                        console.log('Error getting data: ' + error)
                    })

            }

        }

    }

</script>
